<template>
    <div>
        <div class="container">
            <div class="titleBar">
                <span class="mgl20">{{ $t('CreatePage.createDevice') }}</span>
                <el-button class="rightButton" @click="goBack">{{ $t('CreatePage.backButton') }}</el-button>
            </div>
            <el-form class="form-box" :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="80px">
                <div class="formTitle">
                    <span>{{ $t('CreatePage.baseInfo') }}</span>
                </div>
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.company')" prop="company">
                            <el-select
                                v-model="ruleForm.company"
                                class="formWidth"
                                :placeholder="$t('Message.select')"
                                @change="
                                    key => {
                                        changeCompany(key);
                                    }
                                "
                            >
                                <el-option
                                    v-for="item in companySelect"
                                    :key="item.sssid"
                                    :label="item.nickname"
                                    :value="item.sssid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.group')" prop="group">
                            <el-select
                                v-model="ruleForm.group"
                                class="formWidth"
                                :placeholder="$t('Message.select')"
                                :disabled="groupDisable"
                                @change="
                                    key => {
                                        changeGroup(key);
                                    }
                                "
                            >
                                <el-option
                                    v-for="item in groupSelect"
                                    :key="item.sssid"
                                    :label="item.trackergroupname"
                                    :value="item.sssid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.deviceSeries')" prop="deviceSeries">
                            <el-select
                                v-model="ruleForm.deviceSeries"
                                class="formWidth"
                                :placeholder="$t('Message.select')"
                                @change="
                                    key => {
                                        changeSeries(key);
                                    }
                                "
                            >
                                <el-option
                                    v-for="item in seriesSelect"
                                    :key="item.seriesid"
                                    :label="item.seriesname"
                                    :value="item.seriesid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.mode')" prop="mode">
                            <el-select
                                v-model="ruleForm.mode"
                                class="formWidth"
                                :placeholder="$t('Message.select')"
                                :disabled="modeDisable"
                                @change="
                                    key => {
                                        changeMode(key);
                                    }
                                "
                            >
                                <el-option
                                    v-for="item in modeSelect"
                                    :key="item.modelid"
                                    :label="item.modelname"
                                    :value="item.modelid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10" class="mgt20">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.downloadTemplate')">
                            <el-button type="primary" icon="el-icon-download" @click="downloadTemplate">
                                {{ $t('DeviceManage.downloadImportTemplate') }}
                            </el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.uploadFile')">
                            <div class="grid-content">
                                <div class="grid-cont-right">
                                    <el-upload
                                        style="width:50%;margin-bottom:50px"
                                        :action="archiveUrl()"
                                        :headers="headerObj"
                                        :on-success="onArchive"
                                        :before-upload="beforeUploadFile"
                                        :on-change="handleChange"
                                        list-type="fileList"
                                        :limit="1"
                                        ref="uploadRef"
                                        accept=".xlsx"
                                        :auto-upload="false"
                                    >
                                     
                                        <el-button :disabled="uploadDisable" slot="trigger" size="mini" type="primary">{{ $t('Button.selectFile') }}</el-button>
                                        <el-button :disabled="uploadDisable" icon="el-icon-upload" style="margin-left: 10px;" size="mini" type="success" @click="uploadFile">{{
                                            $t('Button.upload')
                                        }}</el-button>
                                    </el-upload>
                                    <div style="margin-bottom:10px" class="font-set">{{$t('DeviceManage.tip')}}</div>
                                    
                                </div>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item class="buttonCenter">
                    <el-button @click="goBack">{{ $t('Button.back') }}</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import Tools from '../../common/Tools.js';
import api from '../../../api/api.js';
import setting from '../../../api/apiSetting.js';

export default {
    name: 'taskCreate',
    components: {},
    data() {
        return {
            labelPosition: 'top',
            multipleSelection: [],
            ruleForm: {
                company: '',
                group: '',
                mode: '',
                deviceSeries: '',
                deviceName: '',
                imei: '',
                sn: '',
                firmwareVer: '',
                configFile: '',
                securityFile: '',
                ip: '',
                port: '',
                cntFOTAfrequency: '',
                cntFOTAenabled: true,
                alarmClock: ''
            },
            companySelect: [],
            groupSelect: [],
            modeSelect: [],
            seriesSelect: [],
            tableData: [],
            loading: false,
            autoMatch: true,
            modeDisable: true,
            groupDisable: true,
            uploadDisable: true,
            batchCreateUri: '',
            uploadExtraData: '',
            fileList: [],
            headerObj: {
                Authorization: 'BasicAuth ' + localStorage.getItem('token')
            }
        };
    },

    computed: {
        rules() {
            return {
                company: [{ required: true, message: this.$t('Rules.require'), trigger: 'blur' }],
                group: [{ required: true, message: this.$t('Rules.require'), trigger: 'blur' }],
                mode: [{ required: true, message: this.$t('Rules.require'), trigger: 'blur' }],
                deviceSeries: [{ required: true, message: this.$t('Rules.require'), trigger: 'blur' }]
            };
        },
        // 新增一个计算属性，确保按钮的禁用状态是响应式的
        realUploadDisable() {
            // 只要uploadDisable为true就禁用按钮，否则可用
            return this.uploadDisable;
        }
    },
    watch: {
        // 监听uploadDisable变化，强制刷新el-upload内部状态
        uploadDisable(val) {
            // 由于el-upload的:disabled属性有时不会响应式更新，手动触发刷新
            this.$nextTick(() => {
                if (this.$refs.uploadRef && this.$refs.uploadRef.$el) {
                    // 触发el-upload的强制更新
                    this.$refs.uploadRef.$forceUpdate();
                }
            });
        }
    },
    created() {
        this.getCompany();
        this.getSeries();
    },

    methods: {
        goBack() {
            this.$router.go(-1);
        },
        getCompany() {
            let params = {
                usersssid: localStorage.getItem('sssid')
            };
            api.getUser(params)
                .then(res => {
                    if (res.state) {
                        this.companySelect = res.value;
                    } else {
                        this.$message.error(res.value.text);
                    }
                })
                .catch(error => {
                    this.$message.error(this.$t('Message.reqError'));
                });
        },
        getGroup(key) {
            let params = {
                usersssid: key
            };
            api.getTrackerGroup(params)
                .then(res => {
                    if (res.state) {
                        this.groupSelect = res.value;
                    } else {
                        this.$message.error(res.value.text);
                    }
                })
                .catch(error => {
                    this.$message.error(this.$t('Message.reqError'));
                });
        },
        getSeries() {
            api.getTrackerSeries().then(res => {
                if (res.state) {
                    this.seriesSelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }
            });
        },
        getMode(key) {
            let params = {
                seriesid: key
            };
            api.getTrackerModels(params).then(res => {
                if (res.state) {
                    this.modeSelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }
            });
        },
        changeSeries(key) {
            this.modeDisable = false;
            this.ruleForm.mode = '';
            this.modeSelect = [];
            this.uploadDisable = true;
            this.getMode(key);
        },
        changeCompany(key) {
            this.groupDisable = false;
            this.ruleForm.group = '';
            this.uploadDisable = true;
            this.getGroup(key);
        },
        changeMode(key) {
            // 只有mode和group都选中时才允许上传
            if (this.ruleForm.mode !== '' && this.ruleForm.group !== '') {
                this.batchCreateUri = setting.geturl() + 'Tracker/BatchCreate';

                this.uploadExtraData = {
                    usersssid: this.getuserID(),
                    groupsssid: this.ruleForm.group,
                    trackerMode: this.ruleForm.mode
                };
                this.uploadDisable = false;
            } else {
                this.uploadDisable = true;
            }
        },
        changeGroup(key) {
            // 只有mode和group都选中时才允许上传
            if (this.ruleForm.mode !== '' && this.ruleForm.group !== '') {
                this.batchCreateUri = setting.geturl() + 'Tracker/BatchCreate';

                this.uploadExtraData = {
                    usersssid: this.getuserID(),
                    groupsssid: this.ruleForm.group,
                    trackerMode: this.ruleForm.mode
                };
                this.uploadDisable = false;
            } else {
                this.uploadDisable = true;
            }
        },
        downloadTemplate() {
            let groupsssid = this.ruleForm.group;
            let id = this.getuserID();
            let url = this.GLOBAL.serverSrc + 'Tracker/DownloadBatchTemplate?filename=template.xlsx&usersssid=' + id + '&groupsssid=' + groupsssid;
            api.downloadEx(this, url, this.$t('DeviceManage.createTemplate'));
        },

        getuserID() {
            let id = localStorage.getItem('sssid');
            if (this.ruleForm.company) {
                id = this.ruleForm.company;
            }
            return id;
        },
        archiveUrl(){
            return this.GLOBAL.serverSrc + "Tracker/BatchCreate?usersssid=" + this.getuserID()+"&groupsssid="+this.ruleForm.group+"&trackerMode="+this.ruleForm.mode;     

        },   
        //文件限制格式、大小
        beforeUploadFile(file){
            let isFormat = file.name.endsWith('.xlsx');
            let islen = (file.size / 20 / 1024 / 1024) <= 1;
            if (!isFormat) {
                this.$message.warning(this.$t('DeviceManage.onlySupportXlsXlsx'));
            }
            if (!islen) {
                this.$message.warning(this.$t('DeviceManage.tipFileLarge'));
            }
            return  isFormat && islen;        
        },          

        //文件上传成功
        onArchive(response, file, fileList) {
            this.$refs.uploadRef.uploadFiles=[]
            this.isUploadFile = true;
            var that = this;           
            if(response.value.success == true){
                that.$message({
                    message: that.$t('DeviceManage.uploadSuccess'),
                    type: 'success'
                })
         
           
            } else {
                that.$message({
                    message: response.value.text,
                    type: 'error'
                })                
            }            
        },

               

        handleChange(file) {
            this.isUploadFile = true;
        },

        
        uploadFile() {
            if(this.$refs.uploadRef.uploadFiles == undefined ||this.$refs.uploadRef.uploadFiles.length==0) {
                this.$message.warning(this.$t('DeviceManage.tipSelectFile'));
                return;
            }            
            this.$refs.uploadRef.submit();
        }
    }
};
</script>

<style scoped>
.el-upload--text {
    background-color: #fff;
    border: 0px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 100px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
</style>
